import { t } from "@auto/services";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import styles from "./votingcentertagtypes.module.styl";

export const VOTING_CENTER_TAG_TYPES = Object.freeze({
  capacityWarning50: {
    label: t("geo.tags.capacity50"),
    aliases: ["capacity-50", "capacity_warning_50", "50%", "50 percent"],
    icon: ReportProblemOutlinedIcon,
    className: styles.tagCapacityWarning50,
    defaultValue: true,
  },

  capacityWarning70: {
    label: t("geo.tags.capacity70"),
    aliases: ["capacity-70", "capacity_warning_70", "70%", "70 percent"],
    icon: ReportProblemOutlinedIcon,
    className: styles.tagCapacityWarning70,
    defaultValue: true,
  },

  capacityFull: {
    label: t("geo.tags.full"),
    aliases: ["capacity-full", "full", "capacity_error", "capacity error"],
    icon: ErrorOutlineOutlinedIcon,
    className: styles.tagCapacityFull,
    defaultValue: true,
  },
});

export default VOTING_CENTER_TAG_TYPES;
